import { getAllHubTrialsByHubIdRpc } from 'trials-service-types';
import { rpcClient } from '../client';
const isExpired = removedAt => removedAt < Date.now();
const trialStateAdapter = trialState => trialState.reduce((transformedTrialState, hubTrial) => {
  const {
    trial: {
      productApiNames
    },
    removedAt
  } = hubTrial;
  for (const apiName of productApiNames) {
    if (removedAt && isExpired(removedAt)) {
      transformedTrialState.expiredTrials.add(apiName);
    } else transformedTrialState.activeTrials.add(apiName);
  }
  return transformedTrialState;
}, {
  activeTrials: new Set(),
  expiredTrials: new Set()
});
const fetcher = async () => {
  const trialStateResponse = await rpcClient.call(getAllHubTrialsByHubIdRpc, {});
  return trialStateAdapter(trialStateResponse);
};
let _trialStateCachedPromise;
export const fetchTrialState = () => _trialStateCachedPromise || (_trialStateCachedPromise = fetcher());
export const resetTrialState = () => _trialStateCachedPromise = undefined;